import { render, staticRenderFns } from "./FieldNote.vue?vue&type=template&id=37d24ac8"
import script from "./FieldNote.vue?vue&type=script&setup=true&lang=ts"
export * from "./FieldNote.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FieldNote.vue?vue&type=style&index=0&id=37d24ac8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports